import { gql } from "apollo-boost"

// export const Categories = gql`
// {
//   allCategories(orderBy: name_ASC){
//     id
//     name
//     file
//     skills {
//       id
//       name
//     }
//   }
// }
// `;

export const Categories = gql`
{
  allCategories{
    id
    name
    file
    skills {
      id
      name
    }
  }
}
`;

export const NewHab = gql`
mutation NewHab($name: String!){
  createHabilidade(
    name: $name
    ){
      name
  }
}
`